export default __webpack_public_path__ + "static/media/Facilities Only - Blue.7bbd5d2e.svg";